import React from 'react';
import { useOpportunity } from "../../providers/OpportunityProvider";
import OppBriefTeamMembersSection from '../talent-opportunities/components/OppBriefTeamMembersSection';

const TeamScopeTab = ({ getStepActions = false }) => {
    const {
        opportunity,
        isDisabled,
        changeProps,
        onRequest
    } = useOpportunity();

    let {
        team,
        client,
        project
    } = opportunity
    let {
        phases
    } = opportunity.project;

    return (
        <React.Fragment>
            <OppBriefTeamMembersSection opportunity={opportunity} />
        </React.Fragment>
    );
};

export default TeamScopeTab;